import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services */
import { DevicesService, MappingService, ScreenService, StateService, AppService } from '@services';

/*Models */
import { Device, DeviceEvent } from '@models';

import { Pager } from '../../shared/pager';

/*Plugins */
import { OwlCarousel } from 'ngx-owl-carousel';
import { IMyDpOptions } from 'mydatepicker';
import * as moment from 'moment';

/*Config */
import { CONFIG } from '../../config';


declare var $: any;

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html'
})

export class EventsComponent implements OnInit, OnDestroy {
  @ViewChild('eventsSlider') eventsSlider: OwlCarousel;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public events: DeviceEvent[];
  public filteredEvents = [];
  public pager: Pager;
  public selectedDate: any;
  public isLoadData = false;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd.mm.yyyy',
    monthSelector: true,
    editableDateField: false,
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    yearSelector: false,
    disableSince: { year: 0, month: 0, day: 0 },
    dayLabels: CONFIG.dayLabels,
    monthLabels: CONFIG.monthLabels
  };

  public filters = [{ isActive: true, name: 'Действия', value: 'userAction' },
  { isActive: true, name: 'Контакты', value: 'contactZone' },
  { isActive: false, name: 'Система', value: 'system' },
  { isActive: true, name: 'Статус', value: 'status' }];
  public currentDevice: Device;


  constructor(
    private devicesService: DevicesService,
    public screenService: ScreenService,
    private stateService: StateService,
    private mappingService: MappingService,
    private appService: AppService) {
    this.pager = new Pager(this.pageSizeCalculator(23));
    this.currentDevice = this.stateService.currentDevice;
    if (this.currentDevice) {
      this.init();
    }
  }

  pageSizeCalculator(lineHeight) {
    const topOffset = $('.events-result').offset();
    let height = window.innerHeight;
    height -= topOffset ? topOffset.top + 25 : 236; // top
    height -= 42; // bottom

    let size = Math.floor(height / lineHeight);
    if (size < 1) {
      size = 1;
    }

    $('.events-result-wrapper').height(size * lineHeight);
    return size;
  }

  ngOnInit() {



    this.stateService.currentDeviceObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        this.currentDevice = device;
        if (this.currentDevice) {
          this.init();
        }

      });
    this.screenService.isDataLoadingObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(value => {
        this.isLoadData = value;
      });
    this.screenService.triggerStateObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(value => {
        setTimeout(() => {
          this.pageSizeCalculator(23);
        });

      });
    this.screenService.isStateHidden = true;
  }
  private init() {
    this.screenService.isDataLoadingSubject.next(true);
    this.initDate();
    this.onDateChanged(null);
  }
  ngOnDestroy() {
    this.screenService.isDataLoadingSubject.next(true);
    this.stateService.autoUpdatePositionSubject.next(true);
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  private initDate() {

    const currentMoment = moment();
    this.selectedDate = { date: { year: currentMoment.year(), month: currentMoment.month() + 1, day: currentMoment.date() } };

    const today = new Date(currentMoment.year(), currentMoment.month(), currentMoment.date());
    const tomorrow = new Date(new Date().setHours(0, 0, 0, 0));

    tomorrow.setDate(today.getDate() + 1);

    const copy = this.getCopyOfOptions();
    copy.disableSince = {
      year: tomorrow.getFullYear(),
      month: tomorrow.getMonth() + 1,
      day: tomorrow.getDate(),
    };
    this.myDatePickerOptions = copy;
  }


  getDetails(event: DeviceEvent) {
    this.stateService.autoUpdatePositionSubject.next(false);

    if (!event.coordinate && !event.provider.eventId) {
      return false;
    }
    if (event.coordinate) {
      this.showEventDetails(event);
      return;
    }

    this.devicesService.getEventDetails(this.currentDevice.id, event.provider.eventId, event.deviceTime)
      .subscribe((eventDetails: DeviceEvent) => {
        this.showEventDetails(eventDetails);
      });
  }

  showEventDetails(eventDetails: DeviceEvent) {
    if(eventDetails.coordinate){
      if(eventDetails.coordinate.latitude){
        eventDetails.coordinate.latitude = parseFloat(eventDetails.coordinate.latitude.toString().replace(",","."))
      }
      if(eventDetails.coordinate.longitude){
        eventDetails.coordinate.longitude = parseFloat(eventDetails.coordinate.longitude.toString().replace(",","."))
      }
    }
    console.log(eventDetails)

    this.mappingService.getAddress(eventDetails.coordinate.latitude, eventDetails.coordinate.longitude, (result) => {
      let content = eventDetails.provider.message;
      content += ' адрес: ' + result.length ? result[0].formatted_address : '';
      this.screenService.setMarker(
        eventDetails.coordinate.latitude,
        eventDetails.coordinate.longitude,
        content,
        eventDetails.coordinate.precision);
      this.screenService.setCenter(eventDetails.coordinate.latitude, eventDetails.coordinate.longitude);
    });
  }

  onDateChanged(dateChangedEvent) {

    this.screenService.isDataLoadingSubject.next(true);

    if (dateChangedEvent) {
      this.selectedDate = dateChangedEvent;
    }
    const userDateTimeOffset = this.appService.userTimezoneOffset();
    const date = this.selectedDate.date;
    const fromMoment = moment.utc({ year: date.year, month: date.month - 1, date: date.day });
    const toMoment = moment.utc({ year: date.year, month: date.month - 1, date: date.day });


    const from = fromMoment.startOf('day').subtract(userDateTimeOffset, 'h').unix();
    const to = toMoment.endOf('day').subtract(userDateTimeOffset, 'h').unix();

    this.devicesService.getEvents(this.currentDevice.id, from, to).subscribe((eventsResult: DeviceEvent[]) => {

      this.screenService.isDataLoadingSubject.next(false);
      // eventsResult.sort((a, b) => a.time - b.time);


      for (const event of eventsResult) {
        event.icon = this.getIcon(event);
      }

      this.events = eventsResult;
      this.showEvents();
    });
  }

  updateFilter(filter) {
    filter.isActive = !filter.isActive;
    this.showEvents();
  }

  showEvents() {
    this.filteredEvents = [];
    this.events.map(event => {
      if (event.level) {
        if (event.group && this.filters.some(filter => filter.value.toLowerCase() === event.group.toLowerCase())) {
          if (this.filters.some(filter => filter.isActive && filter.value.toLowerCase() === event.group.toLowerCase())) {
            this.filteredEvents.push(event);
          }
        } else {
          this.filteredEvents.push(event);
        }
      }

    });
    this.filteredEvents = this.sortArrayDown(this.filteredEvents);

    this.pager.toFirstSlide(this.eventsSlider);
    this.pager.setData(this.filteredEvents);

    this.screenService.isDataLoadingSubject.next(false);

  }
  sortArrayDown(array) {
    return array.sort((obj1, obj2) => {
      if (obj1.deviceTime > obj2.deviceTime) {
        return -1;
      }

      if (obj1.deviceTime < obj2.deviceTime) {
        return 1;
      }

      return 0;
    });
  }
  getIcon(event: DeviceEvent) {
    const mapping = this.mappingService.getEventMapping(event.id);
    if (mapping) {
      return mapping.icon;
    }
    return 'gprs_on';
  }

  getCopyOfOptions(): IMyDpOptions {
    return JSON.parse(JSON.stringify(this.myDatePickerOptions));
  }
}



// WEBPACK FOOTER //
// ./src/app/view/events/events.component.ts